import { NewAdaptPractAndOrgn } from '../../interfaces/interfaces';
import { isRole } from './tsHelper';
import findFnHandlers from './findFns';

const newItem: NewAdaptPractAndOrgn = (item, currentLocation) => {
  const finalMapPractitionerOrOrgan = new Map();
  const finalData = { ...item, data: finalMapPractitionerOrOrgan };

  item?.data.forEach((value, key) => {
    const isTrue = isRole(value);
    const fn = findFnHandlers(value, item, key);

    finalMapPractitionerOrOrgan.set(key, {
      id: fn.findId(),
      name: fn.findName(),
      orgType: fn.findOrgType(),
      pharmacyType: fn.findPharmacyType(),
      findPharmacyChain: fn.findPharmacyChain(),
      role: fn.findRole(),
      gender: fn.findGender(),
      specialty: fn.findGeneralSpecialty(),
      secondarySpecialties: fn.findSecondarySpecialties(),
      codingDisplayOrganization: fn.findCoding(),
      language: fn.findLanguage(),
      catchmentArea: fn.findCatchmentArea(),
      telecom: {
        phone: fn.findContactType('phone'),
        fax: fn.findContactType('fax'),
        email: fn.findContactType('email'),
        url: fn.findContactType('url'),
      },
      registrationProvince: fn.findRegistrationProvince() ?? [],
      billingNumbers: fn.findBillingNumbers() ?? [],
      contact: fn.findContactPerson(),
      location: {
        lat: fn.findValueLat(),
        lng: fn.findValueLng(),
      },
      distanceFromOrigin: fn.findDistanceToOrigin(currentLocation),
      address: {
        fullAddress: fn.findAddress(),
        id: fn.findLocationId(),
        locationSecondary: fn.findLocationSecondary(),
        addressShort: fn.findAddressShort(),
      },
      operationHours: fn.findOperationHours(),
      resourceType: isTrue ? 'Practitioner' : 'Organization',
    });
  });

  return finalData;
};

export default newItem;
